import { render } from "./CadastrarMedico.vue?vue&type=template&id=20278310&scoped=true"
import script from "./CadastrarMedico.vue?vue&type=script&lang=js"
export * from "./CadastrarMedico.vue?vue&type=script&lang=js"

import "./CadastrarMedico.vue?vue&type=style&index=0&id=20278310&scoped=true&lang=css"

import exportComponent from "J:\\Centrion\\projetos\\apracam_ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20278310"]])

export default __exports__